<template>
  <div class="sakana-wrapper">
    <div class="sakana-container">
      <div class="book-wrapper">
        <div class="book-bg"></div>
        <div class="book-outline"></div>
        <div class="saba-skeleton-img">
          <img src="@/assets/img/home/SABA_SKELETON_green.png" alt="さばのスケルトンの絵">
        </div>
        <div class="book-middle-shadow"></div>
        <div v-scroll-animation class="poem-wrapper scroll-animation">
          <p class="p-sakana-title">さかな</p>
          <p class="p-sakana-text">
            さかなよ<br>
            くやしがるおまえは<br>しなった竿にバネを弾く<br>
            身ぶるいのような抵抗が<br>むきだしの命の底力
          </p>
          <p class="p-sakana-text">
            さかなよ<br>
            こときれたおまえは<br>
          </p>
          <p class="p-sakana-text page2">
            わたしと世界を仲直り<br>
            思い出した血潮の流れに<br>安心立命を見出そう
          </p>
          <p class="p-sakana-text">
            さかなよ<br>
            あたらしいおまえは<br>わたしにしずかに歌ってる<br>
            こころにゼロをとりもどし<br>かぎりない透明に<br>水を感じて
          </p>
        </div>
      </div>

      <div class="button-sakana-sound-wrapper">
        <div @click="toggleAudio" class="button-sakana-sound">
          <audio ref="audio" :src="audioSource" @ended="audioEnded"></audio>
          <span v-if="!isPlaying">▶</span>
          <span v-else>◼︎</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AudioPlayer',
  data() {
    return {
      audioSource: 'https://kokozero-static-assets.s3.ap-northeast-1.amazonaws.com/audio/home/sakana.wav',
      isPlaying: false,
    };
  },
  methods: {
    toggleAudio() {
      const audio = this.$refs.audio;
      if (this.isPlaying) {
        audio.pause();
        audio.currentTime = 0;
      } else {
        audio.play();
      }
      this.isPlaying = !this.isPlaying;
    },
    audioEnded() {
      this.isPlaying = false;
    },
  },
};
</script>

<style scoped>
.sakana-wrapper {
  position: relative;
  width: 100%;
  height: 700px;
  margin-bottom: 100px;
}

.sakana-container {
  position: relative;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 50px;
}

.book-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

.book-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to bottom right, rgba(224, 246, 247, 0.8), rgba(140, 180, 180, 0.8)), url('@/assets/img/home/bg_noise_2.png');
  z-index: 1;
}

.book-outline {
  position: absolute;
  width: 700px;
  height: 450px;
  background: #fcfbf8;
  z-index: 2;
  box-shadow:
    2.5px 3px 2.7px rgba(0, 0, 0, 0.043),
    6.4px 7.5px 6.9px rgba(0, 0, 0, 0.06),
    13.1px 15.2px 14.2px rgba(0, 0, 0, 0.075),
    27px 31.4px 29.2px rgba(0, 0, 0, 0.093),
    74px 86px 80px rgba(210, 210, 210, 0.15);
  border: 0.01px solid #e5e5e5;
}

.saba-skeleton-img {
  position: absolute;
  top: 430px;
  transform: translateX(-250px);
  z-index: 4;
}

.saba-skeleton-img img {
  width: 130px;
  height: 50px;
  object-fit: contain;
  transform: rotate(-15deg);
}

.book-middle-shadow {
  position: absolute;
  width: 60px;
  height: 450px;
  background: linear-gradient(to left, rgba(202, 211, 211, 0.005) 0%, rgba(135, 157, 157, 0.3) 20%, rgba(205, 219, 219, 0.01) 80%, rgba(214, 224, 224, 0.001) 100%);
  z-index: 3;
}

.poem-wrapper {
  position: absolute;
  transform: translateY(-50px);
  font-family: "ShipporiMincho";
  display: flex;
  flex-direction: row;
  flex-direction: row-reverse;
  color: #493c33;
  z-index: 4;
}

.sakana-wrapper .p-sakana-title {
  position: relative;
  left: 35px;
  font-size: 13px;
  writing-mode: vertical-rl;
  align-self: flex-start;
  text-indent: 1rem;
  margin-bottom: 0.5rem;
}

.sakana-wrapper .p-sakana-text {
  position: relative;
  left: 25px;
  font-size: 12px;
  writing-mode: vertical-rl;
  margin-left: 6px;
}

.page2 {
  margin-right: 100px;
}

.button-sakana-sound-wrapper {
  position: relative;
  cursor: pointer;
  z-index: 5;
}

.button-sakana-sound {
  transform: translateY(-70px);
  width: 40px;
  height: 40px;
  border-radius: 20%;
  background: #a0bec1;
  box-shadow: 5px 5px 13px #8ea0a2,
    -5px -5px 13px #d3e3e3;
  display: flex;
  justify-content: center;
  align-items: center;
}

.button-sakana-sound span {
  color: #39686c;
}

/* タブレット、スマートフォン向けのスタイル */
@media screen and (max-width: 1024px) {
  .sakana-wrapper {
    height: 550px;
  }

  .book-outline {
    width: 530px;
    height: 340px;
  }

  .book-middle-shadow {
    width: 45px;
    height: 340px;
  }

  .saba-skeleton-img {
    top: 330px;
    transform: translateX(-200px);
  }

  .saba-skeleton-img img {
    width: 110px;
    height: 40px;
  }

  .sakana-wrapper .p-sakana-title {
    font-size: 11px;
    left: 10px;
  }

  .sakana-wrapper .p-sakana-text {
    left: 10px;
    font-size: 11px;
  }

  .page2 {
    margin-right: 60px;
  }

  .button-sakana-sound {
    width: 30px;
    height: 30px;
  }

  .button-sakana-sound span {
    font-size: 12px;
  }
}

@media screen and (max-width: 570px) {

  .sakana-wrapper {
    height: 550px;
    margin-bottom: 0px;
  }

  .book-bg {
    left: 50%;
    transform: translate(-50%, 0);
    width: 100vw;
    height: 500px;
  }

  .book-outline {
    width: 95vw;
    height: calc(95vw * 0.68);
  }

  .book-middle-shadow {
    width: 25px;
    height: calc(95vw * 0.68);
  }

  .saba-skeleton-img {
    top: 55%;
    transform: translateX(0%);
    left: 0px;
  }

  .saba-skeleton-img img {
    width: 90px;
    height: 40px;
  }

  .sakana-wrapper .p-sakana-title {
    font-size: 12px;
    left: 10px;
  }

  .sakana-wrapper .p-sakana-text {
    left: 10px;
    font-size: 11px;
  }

  .page2 {
    margin-right: 60px;
  }

  .button-sakana-sound {
    width: 30px;
    height: 30px;
  }

  .button-sakana-sound span {
    font-size: 12px;
  }


  .sakana-wrapper .p-sakana-title {
    font-size: 9px;
  }

  .sakana-wrapper .p-sakana-text {
    font-size: 9px;
  }

  .page2 {
    margin-right: 33px;
  }

  .button-sakana-sound {
    width: 30px;
    height: 30px;
    transform: translateY(-90px);
  }

  .button-sakana-sound span {
    font-size: 12px;
  }

}
</style>